import type {
  IInteractiveExamDto,
  IInteractiveExamGetAllParams,
  IInteractiveExamResponse,
} from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { publish } from "@api/courses/exams/interactive/publish/api";
import { createPatchApi } from "@api/util/createPatchApi";
import { questions } from "@api/courses/exams/interactive/questions/api";
import { interactiveExamAttempt } from "@api/courses/exams/interactive/attempts/api";
import type { ICourseResponse } from "@api/courses/types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<IInteractiveExamResponse, { course: ICourseResponse }> & {
      metadata: {
        active_exams_count: number;
        taken_exams_count: number;
        untaken_exams_count: number;
      };
    }
  >,
  IPathBaseParam,
  IPaginationParams & IInteractiveExamGetAllParams
>("courses.exams.interactive");
const postApis = createPostApi<
  IApiResponse<IInteractiveExamResponse>,
  IPathBaseParam,
  IInteractiveExamDto
>("courses.exams.interactive");
const getApis = createGetApi<
  IApiResponse<IInteractiveExamResponse>,
  IPathByIdParam,
  object
>("courses.exams.interactive");
const patchApis = createPatchApi<
  IApiResponse<IInteractiveExamResponse>,
  IPathByIdParam,
  IInteractiveExamDto
>("courses.exams.interactive");
const deleteApis = createDeleteApi<
  IApiResponse<IInteractiveExamResponse>,
  IPathByIdParam
>("courses.exams.interactive");

export const interactive = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
  publish,
  questions,
  interactiveExamAttempt,
};
